import React, { Component } from 'react';
import { css } from '@emotion/core';
import styled from '@emotion/styled';

import {
  buildProviderSchedulingUrl,
  updateParams,
  getQueryFromLocation,
} from '../../../shared/utils/urls';
import ProviderCardHeader from '../../components/ProviderCard/ProviderCardHeader';
import { Scaleup } from '../../../legacyCore/Transitions';
import { withWidgetSettings } from '../../../shared/components/WidgetSettings';
import CalendarDateChangePopup from '../../../shared/components/CalendarDateChangePopup';
import { FirstAvailableOpening } from '../../../shared/components/SchedulingCalendar';
import InsuranceIssuerSelectWithData from '../../../shared/components/InsuranceIssuerSelect';

import style from './ProviderScheduling.scss';

const Label = styled('label')(
  ({ theme }) =>
    css`
      font-size: ${theme.fontSizes.xs};
    `
);

class ProviderCard extends Component {
  constructor(props) {
    super(props);

    const { provider, history } = props;

    // Initial computed properties

    this.location = history && history.location;
    this.providerUrl = buildProviderSchedulingUrl(provider.id, {
      location: this.location,
    });
    this.specialistName =
      provider.specialties.nodes.length > 0
        ? provider.specialties.nodes[0].specialistName
        : undefined;

    this.state = {
      selectedInsuranceIssuer: null,
    };
  }

  onChangeSelectedInsuranceIssuer = (value) => {
    const { selectedInsuranceIssuer } = this.state;
    if (selectedInsuranceIssuer && selectedInsuranceIssuer.id === value.id) return;

    this.setState({ selectedInsuranceIssuer: value });
    updateParams(this.props.history, { insuranceIssuerId: value && value.id }, { replace: true });
  };

  location;
  specialistName;
  providerUrl;
  startingDate;
  nextAvailableUrl;

  renderHeader = () => {
    const { provider, isOnWidget } = this.props;

    return (
      <ProviderCardHeader
        provider={provider}
        providerUrl={this.providerUrl}
        providerSpecialty={this.specialistName}
        isOnWidget={isOnWidget}
        toWidget={false}
      />
    );
  };

  renderDateArea = () => {
    const { nextOpeningData, provider, schedule, isOnWidget } = this.props;
    const {
      values: { selectedDate, minDate },
      updateSelectedDate,
    } = schedule;

    return (
      <div className={style['provider-widget__card__date']}>
        <CalendarDateChangePopup
          selectedDate={selectedDate}
          minDate={minDate}
          onChangeSelectedDate={updateSelectedDate}
        />

        {!nextOpeningData.loading && nextOpeningData.nextOpening && (
          <div className="margin-top-sm">
            <Scaleup in>
              <FirstAvailableOpening
                opening={nextOpeningData.nextOpening}
                timeZone={provider.office.timeZoneCode}
                isOnWidget={isOnWidget}
              />
            </Scaleup>
          </div>
        )}
      </div>
    );
  };

  renderInsuranceSelect = () => {
    const { provider } = this.props;
    const { selectedInsuranceIssuer } = this.state;
    const query = getQueryFromLocation(this.location);
    return (
      <div className={style['provider-widget__card__insurance']}>
        <Label htmlFor="insuranceIssuer-input">How will you be paying?</Label>
        <InsuranceIssuerSelectWithData
          id="insuranceIssuer"
          providerId={provider.id}
          selectedItem={selectedInsuranceIssuer}
          initialSelectedValue={this.location && query.insuranceIssuerId}
          onChange={this.onChangeSelectedInsuranceIssuer}
        />
      </div>
    );
  };

  render() {
    const { provider } = this.props;
    const { insuranceCoverageEnabled } = provider.office;

    return (
      <div className={style['provider-widget__card']}>
        {this.renderHeader()}
        {this.renderDateArea()}
        {insuranceCoverageEnabled && this.renderInsuranceSelect()}
      </div>
    );
  }
}

export default withWidgetSettings()(ProviderCard);
